"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const SvgPassword = (props) => (React.createElement("span", { className: "anticon" },
    React.createElement("svg", Object.assign({ fill: "none", viewBox: "0 0 24 24", stroke: "currentColor", xmlns: "http://www.w3.org/2000/svg", className: "PayPing-icon" }, props),
        React.createElement("g", { transform: "matrix(.49383 0 0 .47297 -4.6916 -3.1349)", clipPath: "url(#clip0_2533_12815)" },
            React.createElement("path", { d: "m10 14v36" }),
            React.createElement("path", { d: "m26 24v8" }),
            React.createElement("path", { d: "m18.4 29.525 7.6 2.475" }),
            React.createElement("path", { d: "m21.3 38.475 4.7-6.475" }),
            React.createElement("path", { d: "M 30.7,38.475 26,32" }),
            React.createElement("path", { d: "m33.6 29.525-7.6 2.475" }),
            React.createElement("path", { d: "m50 24v8" }),
            React.createElement("path", { d: "m42.4 29.525 7.6 2.475" }),
            React.createElement("path", { d: "m45.3 38.475 4.7-6.475" }),
            React.createElement("path", { d: "M 54.7,38.475 50,32" }),
            React.createElement("path", { d: "m57.6 29.525-7.6 2.475" })),
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip0_2533_12815" },
                React.createElement("rect", { width: 64, height: 64, fill: "#fff" }))))));
exports.default = SvgPassword;
//# sourceMappingURL=Password.js.map